// index.tsx (or index.ts)
import aparatIcon from "./aparat-icon.svg";
import closeIcon from "./close.svg";
import cloudIcon from "./cloud.png";
import cookiesIcon from "./cookies.png";
import dataIcon from "./data.png";
import editIcon from "./edit.png";
import enamadIcon from "./enamad.svg";
import instagramIcon from "./instagram-icon.svg";
import likeFilledIcon from "./like-filled.svg";
import likeIcon from "./like.svg";
import secureIcon from "./secure.png";
import setBlueIcon from "./set-blue.svg";
import sharingIcon from "./sharing.png";
import supportIcon from "./support.png";
import basketIcon from "./basket.svg";
import sortIcon from "./sort.svg";
import searchIcon from "./search.svg";
import loginLockIcon from "./loginLock.svg";
import clipIcon from "./clip.svg";
import shieldIcon from "./shield.png";
import paymentIcon from "./payment.svg";
import telegramIcon from "./telegram-icon.svg";
import arrowDownIcon from "./arrow-down.png";
import closeDarkIcon from "./close-dark.svg";
import myContentIcon from "./my-content.png";
import ordersIcon from "./orders.png";
import dashboardSupportIcon from "./dashboard-support.png";
import walletIcon from "./wallet-icon.svg";
import OpCP from "./op-cp.svg";
import OpDev from "./op-dev.svg";
import OpDesign from "./op-design.svg";
import OpOp from "./op-operator.svg";
import curvedItemLandingIcon1 from "./curved-items-landing-1.svg";
import curvedItemLandingIcon2 from "./curved-items-landing-2.svg";
import curvedItemLandingIcon3 from "./curved-items-landing-3.svg";
import curvedItemLandingIcon4 from "./curved-items-landing-4.svg";

export const baseIcons = {
  basketIcon,
  loginLockIcon,
  clipIcon,
  aparatIcon,
  sortIcon,
  searchIcon,
  closeIcon,
  closeDarkIcon,
  cloudIcon,
  cookiesIcon,
  dataIcon,
  editIcon,
  enamadIcon,
  instagramIcon,
  likeFilledIcon,
  paymentIcon,
  likeIcon,
  secureIcon,
  setBlueIcon,
  sharingIcon,
  shieldIcon,
  telegramIcon,
  supportIcon,
  arrowDownIcon,
  ordersIcon,
  myContentIcon,
  dashboardSupportIcon,
  walletIcon,
  OpCP,
  OpDesign,
  OpDev,
  OpOp,
  curvedItemLandingIcon1,
  curvedItemLandingIcon2,
  curvedItemLandingIcon3,
  curvedItemLandingIcon4,
};
